import {PageEvent} from '@angular/material/paginator';

export class ServerPageRequest {
  page: number;
  limit: number;

  constructor(item: PageEvent) {
    this.page = item.pageIndex;
    this.limit = item.pageSize;
  }

  firstPage(): void {
    this.page = 0;
  }
}
